<!--
 * 侧边栏导航
 * @author liutong
 * @time 2024-11-08
 *
-->
<!-- 模板(html)代码 start -->
<template>
  <div class="layout-aside" :class="userType === '201508061647340018' ? 'pt20' : '' ">
    <!-- <img class="asideMenu" src="@/assets/images/asideMenu.png"> -->
    <el-select v-model="value" placeholder="项目全部流程" @change="fun_SelectChange" filterable popper-class="asideMenuSelect" v-if="userType === '201508061647340018'">
      <template slot="prefix">
        <img src="@/assets/images/process.png" alt="">
      </template>
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.name"
        :value="item.value">
      </el-option>
    </el-select>
    <div class="menu">
      <div class="menuItem" :class="menuItemId === item.id ? 'activeMenuItem' : ''" v-for="(item, index) in asyncRouters" :key="index">
        <el-tooltip 
          popper-class="menuTooltip" effect="light" 
          placement="right-start" 
          v-if="item.children && item.children.length > 0"
          :open-delay="200"
          :popper-close-delay="2000"
          manual
          v-model="item.tooltipValue"
          :index="item.id">
          <div slot="content" class="menuChildrenCon" @mouseleave="handleMouseLeave($event, item)">
            <div class="menuChildren" :class="routerPath === itemChild.path ? 'menuActive' : ''" v-for="(itemChild, itemChildIndex) in item.children" :key="itemChild.path">
              <div class="itemName" @click="fun_HandleSelect(itemChild.path, item.id)">
                <!-- <i></i> -->
                <img v-if="routerPath === itemChild.path" src="@/assets/images/activeHoverMenuIcon.png" alt="">
                <img v-else src="@/assets/images/hoverMenuIcon.png" alt="">
                <p class="line" v-if="item.children.length !== itemChildIndex + 1"></p>
                <span class="name" :title="itemChild.title" @click="fun_HandleSelect(itemChild.path, item.id)">{{ itemChild.title }}</span>
                <span class="text">{{ itemChild.czsm }}</span>
              </div>
            </div>
            <div class="noLine" v-if="item.children.length < 6"></div>
            <div class="noList" v-if="item.children.length < 6">
              <div class="item">
                <img src="@/assets/images/noMenuChildren.png" alt="">
                <span>没有更多了</span>
              </div>
            </div>
          </div>
          <div class="itemName" :key="item.path" @click="fun_HandleSelect('', item.id)">
            <i :class="'el-icon-' + item.icon"></i>
            <span :title="item.title">{{ item.title }}</span>
            <i class="el-icon-arrow-right r"></i>
          </div>
        </el-tooltip>
        <!-- <div class="itemName" v-else>
          <i :class="'el-icon-' + item.icon"></i>
          <span :title="item.title">{{ item.title }}</span>
        </div> -->
      </div>
    </div>
  </div>
</template>
<!-- 模板(html)代码 end -->

<!-- JS代码 start -->
<script>
import { mapState } from "vuex";
import { fun_PostAction } from "@/api";
/*
 * VUE组件默认导出属性
 * @author 滕威
 */
export default {
  /**
   * 组件默认导出属性
   * @author 滕威
   */
  provide() {
    return {
      reload: this.reload,
    };
  },
  // 初始化数据对象
  data() {
    return {
      activePath: "", // 选中的菜单
      menuItemId: null, // 选中菜单的一级id
      isRouterAlice: true,
      value: null, // 业务流程
      options: [], // 业务流程下拉框
      loginType: sessionStorage.getItem("loginType"), // 用户类型
      userFlag: null, // 用户类型
      userType: null, // 用户类型
    };
  },
  // 计算属性
  computed: {
    ...mapState(["asyncRouters"]),
    // 默认选中路由
    routerPath() {
      // 遍历路由
      this.asyncRouters.map(e=>{
        // 判断是否存在数据
        if(e.children && e.children.length){
          // 遍历子级
          e.children.map(val=>{
            // 判断当前路由
            if(this.$route.path === val.path){
              // 获取父级id
              this.menuItemId = e.id;
            }
          })
        }
      })
      // 删除存储
      this.resetSetItem("flag", "");
      let path = null;
      // 进入详情页面时，侧边栏依然高亮
      if (this.$route.path.indexOf("Detail") > -1) {
        path = this.$route.path.replace("Detail", "");
      } else {
        path = this.$route.path;
      }
      return path;
    },
  },
  watch: {
    // 监听路由对象中的'$route.query'属性
    '$route.query':'getPath'
  },

  // 模板编译完成
  mounted() {
    this.userFlag = sessionStorage.getItem("userFlag") ? sessionStorage.getItem("userFlag") : null;
    this.userType = sessionStorage.getItem("userType") ? sessionStorage.getItem("userType") : null;
    // 页面初始化
    this.fun_Init();
    // 获取全部流程
    this.fun_GetOptionsSelect();
  },

  // 自定义事件
  methods: {
    /**
     * 监听路由传参
     * @param to 当前传递的参数
     * @param from 上一个传递的参数
     */
    getPath(to, from){
      // 判断是切换角色
      if ((to.type === "招标人" || to.type === "投标人" || to.type === "招标代理") && this.$route.path === "/home"){
        // 菜单全部关闭
        this.$refs.menu.openedMenus = [];
      }
    },
    /**
     * 页面初始化
     * @author 滕威
     */
    fun_Init() {
      // 获取选中path
      this.activePath = this.$route.path;
      // 遍历数据
      this.asyncRouters.map(e=>{
        // 添加数据
        this.$set(e, "tooltipValue", false);
      })
    },
    /**
     * @description
     */
    reload() {
      this.isRouterAlice = false;
      this.$nextTick(() => {
        this.isRouterAlice = true;
      });
    },
    /**
     * 选择菜单执行
     * @params key 选中菜单path
     * @author 滕威
     */
    fun_HandleSelect(key, id) {
      // 将选中的菜单path赋值
      this.activePath = key;
      // 获取一级id
      this.menuItemId = id;
      // 遍历数据
      this.asyncRouters.map(e=>{
        // 判断id
        if(e.id === id){
          // 修改数据
          e.tooltipValue = true;
        }else{
          // 修改数据
          e.tooltipValue = false;
        }
      })
      // 跳转
      if(key){
        this.$router.push({ path: key });
        // 遍历数据
        this.asyncRouters.map(e=>{
          // 修改数据
          e.tooltipValue = false;
        })
      }
    },
    /**
     * 鼠标悬浮显示的内容执行
     */
    handleMouseLeave(visible, val){
      // 判断鼠标是否悬浮后移出
      if(visible){
        // 遍历数据
        this.asyncRouters.map(e=>{
          // 判断id
          if(e.id === val.id){
            // 修改数据
            e.tooltipValue = false;
          }
        })
      }
    },
    /**
     * 选择下拉框
     * @author 滕威
     */
    fun_SelectChange(e) {
      // 跳转到工作台
      this.$router.push("/home");
      // 获取对应流程的菜单
      this.fun_GetMenu(e, true);
    },
    /**
     * 获取对应流程的菜单
     * @author 滕威
     */
    async fun_GetMenu(optionType, flag) {
      try {
        // 请求，获取结果集
        let res = await fun_PostAction("/findPower/operationMenu?type=" + this.loginType + "&optionType=" + optionType);
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 更换菜单，存储路由到vuex
          this.$store.commit("SET_ROUTER", data.router);
          // 为true
          if (flag) {
            // 跳转首页
            this.$router.push({path: "/home" });
            // 提示
            this.$message.success("业务流程更换成功")
          }
        }
      } catch {}
    },
    /**
     * 获取全部流程下拉框
     */
    fun_GetOptionsSelect() {
      // 请求，获取结果集
      fun_PostAction("/dataDictionaryEntries/BasicDataCombobox", {
        zdid: '202412161017580012',
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 全部流程下拉框
          this.options = data;
          // 默认显示全部
          this.value = this.options[0].value;
        } else {
          this.$message.error(msg);
        }
      });
    },
  }
};
</script>
<!-- JS代码 end -->

<!-- css样式 start-->
<style lang="scss" scoped>
.layout-aside.pt20 {
  padding-top: 20px;
}
.layout-aside {
  height: 100%;
  box-sizing: border-box;
  /deep/.el-select {
    padding: 0 10px;
    .el-input {
      display: flex;
      align-items: center;
      .el-input__inner {
        padding-left: 42px;
        height: 40px;
        line-height: 40px;
        background: #EAF4FC;
        border-color: #9BC8E8;
        font-weight: bold;
        color: #333333 !important;
        font-size: 16px;
        font-weight: bold;
      }
      @media (min-width: 2160px) {
        .el-input__inner {
          font-size: 18px;
        }
        .el-input__suffix{
          .el-input__suffix-inner{
            .el-select__caret{
              font-size: 16px;
            }
          }
        }
      }
      /* 考虑到兼容的话就是*/
      /* 谷歌 */
      .el-input__inner::-webkit-input-placeholder {
        color:  #333333;
      }
      /* 火狐 */
      .el-input__inner:-moz-placeholder {
        color:  #333333;
      }
      /*ie*/
      .el-input__inner:-ms-input-placeholder {
        color:  #333333;
      }
      .el-select__caret.el-input__icon::before {
        content: "\e78f";
        color: #727781;
      }
      .el-input__prefix {
        display: flex;
        align-items: center;
        left: 12px;
      }
    }
  }
  .asideMenu{
    position: absolute;
    bottom: 0;
    left: 0;
    pointer-events: none;
    z-index: 1;
  }
  .menu{
    .menuItem{
      padding: 0 10px;
      &:hover{
        background: #DEF0FC;
        .itemName{
          &::after{
          }
          i,span{
            color: #0E70B5 !important;
          }
        }
      }
      .itemName{
        height: 60px;
        line-height: 60px;
        cursor: pointer;
        border-bottom: 1px solid #FFFBFB;
        text-align: left;
        padding-left: 13px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;
        display: flex;
        align-items: center;
        &::after {
          content: '';
          pointer-events: none;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 1px;
          background: #C4CDE3;
        }
        i{
          color: #303946;
          font-size: 23px;
          margin-right: 10px;
        }
        i.r{
          font-size: 18px;
          color: #3D3D3E;
        }
        span{
          font-weight: bold;
          font-size: 18px;
          color: #303946;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          flex: 1;
        }
        @media (min-width: 2160px) {
          i.r{
            font-size: 20px;
          }
          span{
            font-size: 20px;
          }
        }
      }
    }
    .activeMenuItem{
      background: #E1ECFF;
      .itemName{
        &::after{
        }
        i,span{
          color: #0E70B5 !important;
        }
      }
    }
  }
}
</style>
<!-- css样式 end-->
